
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 7.4h-.75V5.15A4.756 4.756 0 007 .4a4.756 4.756 0 00-4.75 4.75V7.4H1.5A1.5 1.5 0 000 8.9v6a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5v-6a1.5 1.5 0 00-1.5-1.5zm-3.25 0h-4.5V5.15C4.75 3.91 5.76 2.9 7 2.9s2.25 1.01 2.25 2.25V7.4z","fill":"#525F7F"}})])
          )
        }
      }
    